<template>

  <SideMenuNormal v-if="level === 1" />
  <SideMenuManger v-if="level === 5" />
  <SideMenuAdmin v-if="level >= 10" />
  test : {{ level }}
</template>

<script>
import store from '@/store';

import SideMenuNormal from "@/components/common/SideMenuNormal";
import SideMenuManger from "@/components/common/SideMenuManger";
import SideMenuAdmin from "@/components/common/SideMenuAdmin";

export default {
  name: "sideMenuComponent",
  components: {
    SideMenuNormal,
    SideMenuManger,
    SideMenuAdmin
  },
  computed: {
    level() {
      return store.state.myInfo.mlevel;
    },
  },
  // props : {
  //   myInfo: {}    // NavComponet - myinfo
  // },
  // watch:{
  //   myInfo : function(val){
  //     this.level = val.mlevel;
  //   }
  // },
  // data() {
  //   return {
  //     level: 0,
  //   };
  // },
  methods: {},
  mounted() {},
}
</script>

<style scoped>
button li>a {
  padding-left: 0;
}
</style>
